import { ValueType } from "@/enums/ValueType";

export const nhgPremie = {
	metadata: {
		type: ValueType.Percentage,
	},
	values: {
		"1995-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/iopnvwhp/jaarrekening_1993-94_en_liquiditeitsprognose_1995-2000-1.pdf",
			},
			value: 0.0036,
		},
		"2000-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/xuzbrlrg/jaarverslag_2000_en_liquiditeitsprognose_2001-2006.pdf",
			},
			value: 0.0032,
		},
		"2001-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/zhgfyhvu/jaarverslag_2001_en_liquiditeitsprognose_2002-2007.pdf",
			},
			value: 0.003,
		},
		"2005-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/l2pfcnmc/jaarverslag_2004_en_liquiditeitsprognose_2005-2010.pdf",
			},
			value: 0.0028,
		},
		"2007-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/lmdb3tdv/jaarverslag_2006_en_liquiditeitsprognose_2007-2012.pdf",
			},
			value: 0.004,
		},
		"2009-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/isils5ia/voorwaarden_en_normen_2009-i.pdf",
			},
			value: 0.0045,
		},
		"2010-01-01": {
			metadata: {
				reference:
					"https://weblog.independer.nl/productnieuws/kosten-nationale-hypotheekgarantie-in-2010-omhoog/",
			},
			value: 0.0055,
		},
		"2012-01-01": {
			metadata: {
				reference:
					"https://dehypotheeksite.nl/hypotheekinformatie/nationale-hypotheek-garantie/hoeveel-kost-nationale-hypotheek-garantie.php",
			},
			value: 0.007,
		},
		"2013-01-01": {
			metadata: {
				reference:
					"https://dehypotheeksite.nl/hypotheekinformatie/nationale-hypotheek-garantie/hoeveel-kost-nationale-hypotheek-garantie.php",
			},
			value: 0.0085,
		},
		"2014-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/media/3mljj1zp/voorwaarden_en_normen_2014-1_1__1_november_2013.pdf",
			},
			value: 0.01,
		},
		"2019-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/nhg-premie-in-2019-vastgesteld-op-0-9/",
			},
			value: 0.009,
		},
		"2020-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/archief-nieuwsberichten/nhg-premie-in-2020-verlaagd-naar-0-7/",
			},
			value: 0.007,
		},
		"2022-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/nhg-kostengrens-stijgt-naar-355-000-in-2022-nhg-premie-verlaagd-naar-0-6/",
			},
			value: 0.006,
		},
		"2025-01-01": {
			metadata: {
				reference:
					"https://www.nhg.nl/nhg-actueel/nieuwe-voorwaarden-en-normen-in-2025/",
			},
			value: 0.004,
		},
	},
};
